<template>
    <Modal ref="modal"
           :hideFooter="true"
           title="חיפוש לקוחות ואירועים">

        <template v-slot:body>

            <input placeholder="חיפוש"
                   ref="findCustomerModalTextInput"
                   class="form-control"
                   style="margin:15px auto 15px auto;display:block;"
                   v-model="searchTerm">

            <!-- how many were found (the whole list, up to the api's limit) -->
            <div v-if="resultsLine"
                 class="findCustomerResultsLine"
                 style="color:rgb(119,119,119);font-size:13px;margin:-8px 0 8px 0">
                {{ resultsLine }}
            </div>

            <!-- the list scrolls, the search box stays in view -->
            <div class="findCustomerResults" style="max-height:60vh;overflow-y:auto">

                <div v-for="searchResult in searchResults"
                     class="autocompleteResult"
                     style="display:flex;align-items:center;gap:10px"
                     @click="chooseCustomer(searchResult)">

                    <img style="height:40px;width:40px;border-radius:100%;flex-shrink:0"
                         loading="lazy"
                         :src="searchResult.contactsDisplayJson && searchResult.contactsDisplayJson[0] && searchResult.contactsDisplayJson[0].pic ? 'https://planup-il.s3.eu-central-1.amazonaws.com/' + searchResult.contactsDisplayJson[0].pic : $globals.getLetterImage(searchResult.contactNames)">

                    <span style="flex:1">
                        <span>
                            {{ searchResult.contactNames }}
                        </span>

                        <span v-if="searchResult.eventName">
                            -
                            {{ searchResult.eventName }}
                        </span>

                        <span v-if="searchResult.deleted"
                              style="color:rgb(119,119,119);font-size:12px">
                            (בארכיון)
                        </span>
                    </span>

                    <span style="color:rgb(119,119,119)">
                        {{ searchResult.eventClass }}
                    </span>

                    <span style="color:rgb(119,119,119)">
                        {{ $globals.niceDate(searchResult.eventDate) }}
                    </span>
                    





                </div>

            </div>

        </template>

    </Modal>
</template>
<script>
import axiosV2 from "../../core/http/axios_api_v2";
import { debounce } from "../../helpers/interaction";

export default {
    name: "FindCustomerModal",
    data() {
        return {
            searchTerm: "",
            searchResults: [],
            moreResults: false,     // the api had more rows than it sends (search-results findAll's limit)
            randomValueToWaitFor: Math.random(),

            callbackWhenFound: null,

        };
    },
    mounted() {
        this.search();
    },
    computed: {
        // under 2 letters the list is the latest customers, not a search - no count then
        resultsLine() {
            if (!this.searchTerm || this.searchTerm.length < 2 || !this.searchResults.length)
                return '';

            if (this.moreResults)
                return 'מוצגות ' + this.searchResults.length + ' התוצאות הראשונות - הוסיפו עוד מילה כדי לצמצם';

            return this.searchResults.length == 1 ? 'נמצאה תוצאה אחת' : 'נמצאו ' + this.searchResults.length + ' תוצאות';
        },
    },
    watch: {
        searchTerm() {
            this.searchResults = [];
            this.moreResults = false;
            debounce(this.search, 800)();
        }
    },
    methods: {
        chooseCustomer(customer) {
            // debugger;
            this.hide();
            this.$root.$emit('hideQuickCalendar');
            // this.$emit('found',customer);
            this.callbackWhenFound(customer);       // we call the callback with a new field on the customer - chosenEvent
        },
        show(callback) {
            // debugger;
            this.$refs.modal.show();
            this.callbackWhenFound = callback;
            this.searchTerm = '';

            setTimeout(() => { this.$refs.findCustomerModalTextInput.focus() }, 300)

        },
        hide() {
            this.$refs.modal.hide()
        },
        search() {

            if (!this.searchTerm || this.searchTerm.length<2) {
                this.checkSearchResults({results:this.$store.state.emptyAutocomplete})
                return;
            }


            // axiosV2(`/customers/autocomplete?term=${this.searchTerm}&random=${this.randomValueToWaitFor}`).then(result => this.checkSearchResults(result.data));

            axiosV2(`/search-results/?term=${encodeURIComponent(this.searchTerm)}&random=${this.randomValueToWaitFor}`).then(result => this.checkSearchResults(result.data));
        },
        checkSearchResults(searchResult) {

            if (searchResult.random != this.randomValueToWaitFor && this.searchTerm)
                return;


            let resultsToShow = [];

            for (let i = 0; i < searchResult.results.length; i++) {



                if (!searchResult.results[i]?.events?.length) {
                    resultsToShow.push(searchResult.results[i]);
                    continue;
                }



                if (searchResult.results[i].events.length == 1) {
                    searchResult.results[i].chosenEvent = searchResult.results[i].events[0];
                    resultsToShow.push(searchResult.results[i]);
                    continue;
                }


                for (let j = 0; j < searchResult.results[i].events.length; j++) {
                    let newResult = deepCopy(searchResult.results[i]);
                    newResult.chosenEvent = searchResult.results[i].events[j];
                    resultsToShow.push(newResult);
                }


            }

            this.searchResults = resultsToShow;
            this.moreResults = !!searchResult.more;

        }
    },
    components: {}
}
</script>